import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const MessageCircle: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'm3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z' }]],
];

export default MessageCircle;
